export default "__VITE_ASSET__CDsHM$_H__"